import { render, staticRenderFns } from "./AdministrativeFileForm.vue?vue&type=template&id=781971a9&"
import script from "./AdministrativeFileForm.vue?vue&type=script&lang=js&"
export * from "./AdministrativeFileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports